import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteAssessmentItemQuestionMutation, deleteAssessmentItemQuestionMutationVariables } from '../generated/deleteAssessmentItemQuestionMutation';
import { assessmentItemQuestionFieldsFragment } from '../models/AssessmentItemQuestion';

/**
 * Get a callback to delete a AssessmentItemQuestion in the store.
 */
export function useDeleteAssessmentItemQuestionCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteAssessmentItemQuestionMutation, deleteAssessmentItemQuestionMutationVariables>(
        gql`
            mutation deleteAssessmentItemQuestionMutation ($id: ID!) {
                deleteAssessmentItemQuestion(id: $id) {
                    ...assessmentItemQuestionFields
                }
            }

            ${assessmentItemQuestionFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
